"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(require("./MenuItem"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/MenuItem/index.js
 ** module id = 386
 ** module chunks = 0
 **/